import { IListViewField } from "src/components/Shared/ILIstViewField";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";
import { AppEntities } from "src/config/entities";

const CashOpeningBalancesList = () => {
  const fields: IListViewField[] = [
    {
        fieldName: "id",
        title: "Id",
        fieldType: "string",
    },
    {
        fieldName: "companyName",
        title: "Company",
        fieldType: "string",
    },
    {
        fieldName: "totalAmount",
        title: "Total Amount",
        fieldType: "number",
        format: {
            type: "fixedPoint",
            precision: 2,
        },
    },
];
  return (
    <>
      <ListView fields={fields} entity={AppEntities.CashOpeningBalances} createMoreActions={[]}>
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};

export default CashOpeningBalancesList;
